let config = {
	id: null,
	env: null,
	router: null,
	scriptSrc: 'https://mc.yandex.ru/metrika/tag.js',
	defer: true,
}

function updateConfig(options) {
	config = { ...config, ...options }

	if (config.params.defer === undefined) {
		config.params.defer = config.defer
	}

	if (config.id) {
		config.id = Number(config.id)
	}
}

function loadScript() {
	window.addEventListener(
		'load',
		function (e) {
			const script = document.createElement('script')

			script.src = config.scriptSrc

			document.head.appendChild(script)
		},
		{ once: true },
	)
}

function createMetrika(Vue) {
	window.ym =
		window.ym ||
		function () {
			;(window.ym.a = window.ym.a || []).push(arguments)
		}
	window.ym.l = 1 * new Date()

	function metrika() {
		window.ym(config.id, ...arguments)
	}
	metrika('init', config.params)

	return (Vue.prototype.$ym = Vue.$ym = metrika)
}

function startTracking(metrika) {
	if (config.router)
		config.router.afterEach(function (to, from) {
			let origin = window.location.origin,
				toPath = origin + to.fullPath,
				fromPath = from.name ? origin + from.fullPath : document.referrer

			metrika('hit', toPath, {
				referer: fromPath,
			})
		})
}

export default function (Vue, options = {}) {
	updateConfig(options)
	startTracking(createMetrika(Vue))

	if (config.id && config.env === 'production') {
		loadScript()
	}
}
